import React from 'react';
import classNames from 'classnames';
import Cloud from '@/components/notification/cloud';
import ErrorIcon from '@/images/svgs/notification-error.svg';
import SuccessIcon from '@/images/svgs/notification-success.svg';
import { NotificationProps, NotificationVariants } from '@/types';

const Notification: React.FC<NotificationProps> = ({
  title,
  message,
  variant,
  close
}) => {
  const overlayClasses = classNames(
    variant,
    'group absolute w-full h-full z-[11] top-0 left-0 flex justify-center items-center',
    'after:z-0 after:absolute after:bottom-0 after:left-0 after:w-full after:h-full',
    'after:bg-gradient-to-t after:from-black/50 after:to-transparent'
  );

  const variantClasses = classNames(
    'group/variante absolute z-[13] top-0 left-[50%] translate-y-[125%] translate-x-[-50%]'
  );

  return (
    <div className={overlayClasses} onClick={() => close(variant)}>
      {variant == NotificationVariants.SUCCESS && (
        <SuccessIcon className={variantClasses} />
      )}
      {variant == NotificationVariants.ERROR && (
        <ErrorIcon className={variantClasses} />
      )}
      <div className="absolute z-[13] w-[23rem] top-[50%] translate-y-[-30%]">
        <p className="text-center text-title-3 group-[.error-notification]:text-red-600  group-[.success-notification]:text-primary mb-4">
          {title}
        </p>
        <p className="text-center text-input group-[.error-notification]:text-red-600 group-[.success-notification]:text-primary">
          {message}
        </p>
      </div>
      <Cloud variant={variant} />
    </div>
  );
};

export default Notification;
